import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const toMinutes = (t: string | null | undefined): number | null => {
  if (!t) return null;
  const ampm = /([ap])m/i.exec(t);
  const [hStr, mStr] = t.replace(/\s*[ap]m/i, '').split(':');
  let h = parseInt(hStr, 10);
  const m = parseInt(mStr, 10);
  if (isNaN(h) || isNaN(m)) return null;
  if (ampm) {
    const isPm = ampm[1].toLowerCase() === 'p';
    if (isPm && h !== 12) h += 12;
    if (!isPm && h === 12) h = 0;
  }
  return h * 60 + m;
};

/**
 * Validates a break start/end time against the duty window.
 *  - boundStartField..boundEndField = allowed window
 *      continuous:      firstSlotStartTime .. firstSlotEndTime
 *      non-continuous:  firstSlotStartTime .. secondSlotEndTime
 *  - otherBreakField = sibling break control (for the start<end order check)
 *  - isBreakStart flips the order comparison
 * Overnight windows (end <= start) are wrapped by +24h.
 */
export function breakTimeRangeValidator(
  boundStartField: string,
  boundEndField: string,
  otherBreakField: string,
  isBreakStart: boolean
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control.parent;
    if (!group) return null;

    const value = toMinutes(control.value);
    if (value === null) return null; // empty / format handled elsewhere

    const lower = toMinutes(group.get(boundStartField)?.value);
    let upper = toMinutes(group.get(boundEndField)?.value);
    if (lower === null || upper === null) return null; // window not ready yet

    if (upper <= lower) upper += 1440;          // overnight window
    let v = value;
    if (v < lower) v += 1440;

    if (v < lower || v > upper) return { breakOutOfRange: true };

    const other = toMinutes(group.get(otherBreakField)?.value);
    if (other !== null) {
      let o = other;
      if (o < lower) o += 1440;
      if (isBreakStart ? v >= o : v <= o) return { breakOrderInvalid: true };
    }
    return null;
  };
}